// TODO 18888: this component will likely be retired

import React, { useState } from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import BackgroundImage from 'gatsby-background-image';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { convertToBgImage } from 'gbimage-bridge';

import { media, colors, Text, Container, Label, AnimateIn } from '../ui-components';

import Quote from '../assets/icons/quote.svg';

/**
 * Component that renders a quote carousel
 *
 * @component QuoteCarouselLegacy
 * 
 * @param {object} props
 * 
 * @prop {string} className
 * @prop {object} quotes
 * 
 * @return {JSX}
 */
const QuoteCarouselLegacy = props => {
  const { className, quotes } = props;

  const [activeIndex, setActiveIndex] = useState(0);

  /**
   * Decrement the active index by 1 or go to the last slide index
   *
   * @param {object} e
   */
  const previousSlideHandler = e => {
    e.preventDefault();

    let index = activeIndex;
    if (index < 1) index = quotes.length;
    setActiveIndex(--index);
  };

  /**
   * Increment the active index by 1 or go to the first slide index
   *
   * @param {object} e
   */
  const nextSlideHandler = e => {
    e.preventDefault();

    let index = activeIndex;
    if (index === quotes.length - 1) index = -1;
    setActiveIndex(++index);
  };

  /**
   * Renders the quote slide
   *
   * @function renderCarouselItem
   * 
   * @param {object} quote
   * @param {number} index
   * 
   * @returns {JSX}
   */
  const renderCarouselItem = (quote, index) => {
    const image = getImage(quote?.avatarData?.fluid);
    const bgImage = convertToBgImage(image);

    return (
      <ItemWrapper className={index === activeIndex ? 'active' : ''} key={index}>
        {image ? (
          <>
            <DesktopBackgroundImage Tag="section" className={className} alt={quote.author} {...bgImage} />
            <MobileImageWrapper>
              {
                <GatsbyImage
                  image={image}
                  title={quote?.avatarData?.title}
                  style={{ width: '100%' }}
                  alt={quote.author}
                />
              }
            </MobileImageWrapper>
          </>
        ) : (
          <>
            <EmbeddedDesktopBackgroundImage
              Tag="section"
              className={className}
              src={quote.image}
              style={{ marginBottom: '0', zIndex: '10' }}
              alt={quote.author}
            />
            <MobileImageWrapper>
              {<img src={quote.image} alt={quote.author} style={{ width: '100%' }} />}
            </MobileImageWrapper>
          </>
        )}

        <QuoteWrapper>
          <AnimateIn trigger={index === activeIndex}>
            <img src={Quote} alt="Quote Icon" />
            {quote.client && <QuoteLabel>{`Project Spotlight - ${quote.client}`}</QuoteLabel>}
            <QuoteText>{quote.quote}</QuoteText>
            <Text>{quote.author}</Text>
            <AuthorTitleText>{quote.authorSubtitle}</AuthorTitleText>
          </AnimateIn>
        </QuoteWrapper>
      </ItemWrapper>
    );
  };

  return (
    <QuotesContainer className={(className, quotes[0]?.imageData?.fluid ? '' : 'embedded-quote')}>
      {quotes.length > 0 && quotes.map((quote, index) => renderCarouselItem(quote, index))}
      {quotes.length > 1 && (
        <NavigationWrapper>
          <a onClick={previousSlideHandler} href="#">
            {/* TODO: Colors need updated along with this component pending design. */}
            <ArrowLeft size={35} color={colors.crederaRed} />
          </a>
          <a onClick={nextSlideHandler} href="#">
            <ArrowRight size={35} color={colors.crederaRed} />
          </a>
        </NavigationWrapper>
      )}
    </QuotesContainer>
  );
};

const QuotesContainer = styled(Container)`
  position: relative;
  z-index: 9;
  overflow: hidden;
  padding: 0;

  &.embedded-quote {
    padding: 0;
  }
`;

const ItemWrapper = styled.div`
  display: block;
  align-items: flex-end;
  visibility: hidden;
  opacity: 0;
  height: 0;

  &.active {
    visibility: visible;
    opacity: 1;
    height: auto;
  }

  @media (min-width: ${media.largeBottom}) {
    display: flex;
  }
`;

const MobileImageWrapper = styled.div`
  display: flex;
  position: relative;
  z-index: 1;

  img {
    margin-bottom: 0;
  }

  @media (min-width: ${media.largeBottom}) {
    display: none;
  }
`;

const DesktopBackgroundImage = styled(BackgroundImage)`
  display: none;

  @media (min-width: ${media.largeBottom}) {
    display: flex;
    height: 350px;
    min-width: 350px;
    background-position: bottom center;
    background-color: ${colors.midnightBlack};
    background-repeat: repeat-y;
    background-size: cover;
  }
`;

const EmbeddedDesktopBackgroundImage = styled.img`
  display: none;

  @media (min-width: ${media.largeBottom}) {
    display: flex;
    height: 350px;
    min-width: 350px;
    background-position: bottom center;
    background-color: ${colors.midnightBlack};
    background-repeat: repeat-y;
    background-size: cover;
  }
`;

const QuoteWrapper = styled.div`
  padding: 40px;
  background-color: ${colors.lightSky};
  margin-left: 0;

  @media (min-width: ${media.largeBottom}) {
    padding: 40px 40px 40px 80px;
    margin-left: -40px;
    min-height: 520px;
  }
`;

const QuoteLabel = styled(Label)`
  color: ${colors.midnightBlack};
  margin-bottom: 20px;
`;

const QuoteText = styled(Text)`
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 40px;

  @media (min-width: ${media.largeBottom}) {
    font-size: 24px;
    line-height: 40px;
  }
`;

const AuthorTitleText = styled(Text)`
  font-style: italic;
  max-width: 170px;

  @media (min-width: ${media.largeBottom}) {
    max-width: none;
  }
`;

const NavigationWrapper = styled.div`
  position: absolute;
  bottom: 70px;
  right: 50px;
  display: flex;

  a {
    line-height: 1;
    margin-left: 10px;
  }

  @media (min-width: ${media.largeBottom}) {
    right: 110px;
  }
`;

export default QuoteCarouselLegacy;
